import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { PlayerProvider, usePlayer } from "@/context/PlayerContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AudioPlayer from "@/components/AudioPlayer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Episodes from "@/pages/Episodes";
import EpisodeDetail from "@/pages/EpisodeDetail";
import Voices from "@/pages/Voices";
import Press from "@/pages/Press";
import Login from "@/pages/Login";
import HostInbox from "@/pages/HostInbox";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const PlayerBar = () => {
    const { current } = usePlayer();
    return (
        <>
            {current && <div className="h-28" data-testid="player-spacer" />}
            <AudioPlayer />
        </>
    );
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App">
            <AuthProvider>
                <PlayerProvider>
                    <BrowserRouter>
                        <ScrollManager />
                        <div className="grain-overlay" aria-hidden="true" />
                        <Header />
                        <main>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/episodes" element={<Episodes />} />
                                <Route path="/episodes/:id" element={<EpisodeDetail />} />
                                <Route path="/voices" element={<Voices />} />
                                <Route path="/press" element={<Press />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/host" element={<HostInbox />} />
                            </Routes>
                        </main>
                        <Footer />
                        <PlayerBar />
                        <Toaster position="top-center" richColors />
                    </BrowserRouter>
                </PlayerProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
